import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import translations from '../../data/translation'; // translation 객체를 import
import useStoreNo from '../../hooks/useStoreNo';
import { userLogin } from '../../reducers/userInfo';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    isCancel: true,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const userInfo = useSelector(state => state.userInfo);
  const [user, setUser] = useState({ loginId: '', loginPwd: '', jwt: '' });
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const language = useSelector(state => state.language.language); // redux에서 언어 상태 가져오기
  const t = translations[language]; // 현재 언어에 따른 번역 객체 가져오기
  const storeNo = useStoreNo();

  const closeModal = () => {
    setModalOpen(false);
  };

  const doModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'login') {
      goLogin();
    }
  };
  const handleInputChange = e => {
    const { name, value } = e.target;
    setUser(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleCheckboxChange = e => {
    setKeepLoggedIn(e.target.checked);
  };

  const getUser = async () => {
    try {
      const response = await axios.get(`${Config.API_SERVER}profile`, {
        withCredentials: true, // ← 반드시 config 객체 안에 포함
      });

      if (response && response.data && response.data.data) {
        const userInfo = response.data.data;

        let storeName = null;

        if (userInfo.storeNo) {
          try {
            const storeResponse = await axios.get(
              `${Config.API_SERVER}store/${userInfo.storeNo}`,

              { withCredentials: true }
            );

            if (
              storeResponse &&
              storeResponse.data &&
              storeResponse.data.data
            ) {
              storeName = storeResponse.data.data.storeName;
            }
          } catch (storeError) {}
        }

        const user = {
          userNo: userInfo.adminNo,
          id: userInfo.adminId,
          pwd: userInfo.password,
          //jwtToken: jwtToken,
          name: userInfo.adminName,
          mobile: userInfo.mobile,
          zipCode: userInfo.zipCode,
          addr: userInfo.addr,
          detAddr: userInfo.detAddr,
          role: userInfo.role,
          storeNo: userInfo.storeNo,
          storeName: storeName,
        };

        dispatch(userLogin(user));
        return user;
      }
    } catch (e) {}
    return null;
  };

  const waitForPersistedUser = async (timeoutMs = 1500) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      try {
        const persisted = localStorage.getItem('persist:root');
        if (persisted) {
          const root = JSON.parse(persisted);
          const userInfoStored =
            root && root.userInfo ? JSON.parse(root.userInfo) : null;
          if (userInfoStored && userInfoStored.id) {
            return true;
          }
        }
      } catch (err) {}
      await new Promise(r => setTimeout(r, 50));
    }
    return false;
  };

  const goLogin = async () => {
    try {
      await axios.post(
        `${Config.API_SERVER}login`,
        {
          adminId: user.loginId,
          password: user.loginPwd,
          autoLogin: keepLoggedIn,
        },
        { withCredentials: true }
      );

      const fetchedUser = await getUser();

      if (keepLoggedIn) {
        localStorage.setItem('autologin', 'true');
      } else {
        localStorage.removeItem('autologin');
      }

      await waitForPersistedUser();
      const nextStoreNo =
        (fetchedUser && fetchedUser.storeNo) ||
        storeNo ||
        (JSON.parse(localStorage.getItem('persist:root'))?.userInfo
          ? JSON.parse(
              JSON.parse(localStorage.getItem('persist:root')).userInfo
            )?.storeNo
          : null);
      if (nextStoreNo) {
        try {
          localStorage.setItem('last_storeNo', String(nextStoreNo));
        } catch (_) {}
        navigate(`/${nextStoreNo}/gift-list`);
      } else {
        navigate('/gift-list');
      }
    } catch (e) {
      const status = e?.response?.status;
      let message = t.loginFailed;
      if (status === 404) {
        message = t.userNotFound;
      } else if (status === 401) {
        message = t.incorrectPassword;
      } else if (status === 403) {
        message = t.storeDeactivated;
      }
      // 카탈로그: 서버 메시지 노출하지 않고 status 기반 사용자 메시지 사용

      setModalInfo(prev => ({
        ...prev,
        isCancel: false,
        isConfirm: true,
        isMessage: true,
        headerMsg: t.loginFailed,
        actionFlag: 'error',
        mainMsg: message,
      }));
      setModalOpen(true);
    }
  };
  useEffect(() => {
    const autoLogin = localStorage.getItem('autologin') === 'true';
    setKeepLoggedIn(autoLogin);
    if (userInfo.id) {
    }
  }, [userInfo.id]);

  useEffect(() => {
    const adminIdFromUrl = searchParams.get('adminId');

    if (adminIdFromUrl) {
      setUser(prev => ({ ...prev, loginId: adminIdFromUrl }));
    }
  }, [searchParams]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.adminLogin}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box_04">
          <article className="signup_07">
            <h2 className="tit_01">{t.adminLogin}</h2>
          </article>

          <article className="contants_box_03">
            <form
              onSubmit={e => {
                e.preventDefault();
                goLogin();
              }}
            >
              <table className="login_box">
                <tbody>
                  <tr>
                    <th>{t.username}</th>
                    <td>
                      <input
                        className="input_03"
                        type="text"
                        name="loginId"
                        value={user.loginId}
                        onChange={handleInputChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>{t.password}</th>
                    <td>
                      <div style={{ position: 'relative' }}>
                        <input
                          className="input_03"
                          type={showPassword ? 'text' : 'password'}
                          name="loginPwd"
                          value={user.loginPwd}
                          onChange={handleInputChange}
                          style={{ paddingRight: 34, boxSizing: 'border-box' }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(v => !v)}
                          aria-label={
                            showPassword ? '비밀번호 숨기기' : '비밀번호 보기'
                          }
                          style={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            fontSize: 16,
                            lineHeight: 1,
                            padding: 0,
                          }}
                        >
                          {showPassword ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                type="submit"
                style={{ display: 'none' }}
                aria-hidden="true"
              />
            </form>
          </article>

          <div className="signup_08">
            <label className="check_box">
              {t.keepLoggedIn}
              <input
                type="checkbox"
                checked={keepLoggedIn}
                onChange={handleCheckboxChange}
              />
              <span className="check_check"></span>
            </label>

            <article className="button_box_01">
              <button
                type="button"
                className="button_01 button_06 button_red"
                onClick={goLogin}
              >
                {t.login}
              </button>
            </article>
            <article className="button_box_01">
              <button
                type="button"
                className="button_01 button_07 button_gray_line"
                onClick={() =>
                  (window.location.href = `${Config.SHOPMAIN_SERVER}login-idsearch`)
                }
              >
                {t.findUsername}
              </button>
              <br />
              <button
                type="button"
                className="button_01 button_07 button_gray_line"
                onClick={() =>
                  (window.location.href = `${Config.SHOPMAIN_SERVER}login-pwdsearch`)
                }
              >
                {t.findPassword}
              </button>
            </article>
            <article className="button_box_01">
              <button
                type="button"
                className="button_01 button_06 button_gray_line_bg"
                onClick={() =>
                  (window.location.href = `${Config.SHOPMAIN_SERVER}user-signup`)
                }
              >
                {t.signUp}
              </button>
            </article>
          </div>
        </section>
      </main>
    </>
  );
}
